import styled from 'styled-components';

const PocketStyled = styled.div`
  .Pocket {
    &__header {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      &__title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    &__content {
      display: none;

      &--open {
        display: block;
      }
    }

    &__icon {
      transform: rotate(0);
      transition: transform 0.4s ease;

      &--rotate {
        transform: rotate(180deg);
      }
    }
  }
`;

export { PocketStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
